import styled, { css } from 'styled-components';
import getBackgroundColor from '../get-background-color';

const Card = styled.div`
  flex-grow: 1;
  display: flex;
  flex-direction: column;

  border-radius: 0.2rem;
  background-color: ${({ theme }) => theme.pagebuilder?.backgroundGrey || theme.grayLightColor};
  padding: 2rem;
  width: 100%;
  box-sizing: border-box;

  ${({ $contentTheme }) => $contentTheme === 'light' && css`
    background-color: white;
  `}

  ${({ $backgroundColor, $customBackgroundColor, theme }) => ($backgroundColor || $customBackgroundColor) && css`
    background-color: ${getBackgroundColor(theme, $backgroundColor, $customBackgroundColor)};
  `}

  ${({ $transparent }) => $transparent && css`
    background-color: transparent;
  `}

`;

export default Card;
